import { render } from "./NewBoardList.vue?vue&type=template&id=28fe4e46&scoped=true&ts=true"
import script from "./NewBoardList.vue?vue&type=script&lang=ts"
export * from "./NewBoardList.vue?vue&type=script&lang=ts"

import "./NewBoardList.vue?vue&type=style&index=0&id=28fe4e46&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fe4e46"]])

export default __exports__